import type { DateFormat } from "./types";

let activeDateFormat: DateFormat = "BS";

export const getDateFormat = (): DateFormat => activeDateFormat;

export const setDateFormat = (format: DateFormat) => {
  activeDateFormat = format;
};
